import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./AboutSection.css";
import { Link } from "react-router-dom";

function AboutSection() {
  return (
    <section className="aboutSection">
      <Container>
        <Row className="align-items-center">
          {/* LEFT IMAGES */}
          <Col md={6} className="aboutSection-left">
            <div className="about-img-wrapper">
              <img
                src="/assets/images/gallery/img_1.webp"
                alt="Hotel Interior"
                className="about-img-main"
              />
              <img
                src="/assets/images/gallery/img_2.webp"
                alt="Hotel Room"
                className="about-img-small"
              />
            </div>
          </Col>

          {/* RIGHT CONTENT */}
          <Col md={6} className="aboutSection-right">
            <p className="about-subtitle">About Us</p>

            <h2 className="about-title">
              A Serene Hilltop Escape at <br />
              Jaltaara – New Mahabaleshwar
            </h2>

            <p className="about-desc">
              Nestled in the untouched beauty of Tetali, Jawali, Jaltaara is a
              peaceful hilltop retreat where nature whispers, the mountains
              embrace you, and every moment feels timeless. Surrounded by lush
              greenery, cool breezes, and breathtaking valley views, our resort
              offers the perfect getaway for families, couples, and nature
              lovers seeking calmness away from city life.
            </p>

            <p className="about-desc">
              At Jaltaara, we blend rustic charm with modern comfort. Our
              well-designed rooms, warm hospitality, and tranquil surroundings
              make every stay memorable. Whether you're unwinding with scenic
              sunsets, exploring nearby viewpoints, or simply relaxing in the
              fresh mountain air, Jaltaara gives you an experience that feels
              personal, soothing, and close to nature.
            </p>

            <ul className="about-list">
              <li>
                ✔ Located in the heart of New Mahabaleshwar’s natural beauty
              </li>
              <li>
                ✔ Peaceful and family-friendly environment with scenic views
              </li>
              <li>
                ✔ Cozy rooms designed for comfort, privacy, and relaxation
              </li>
              <li>
                ✔ Warm hospitality and a calm atmosphere that feels like home
              </li>
            </ul>

            <Link to={"/about-us"}>
              <Button className="about-btn">DISCOVER MORE</Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutSection;
